import '../destinations_index_packed/destinations_index.js'
import '../../utils/scroll_lock.js'

import Swiper from 'swiper'
import { Controller, Navigation, Pagination, Scrollbar } from 'swiper/modules'

import { currentDevice } from '../../core/utils/currentDevice.js'
import BottomSheet, { createBottomSheet } from '../../shared/bottom_sheet/bottom_sheet.js'
import fastbooking from '../../shared/fastbooking/ibh_fastbooking.js'
import { hideHeaderStickyHotel } from '../../shared/header_sticky_hotel/header_sticky_hotel.js'
import Modal from '../../shared/modal/modal.js'
import {
  handlerSwiperStatusVideo,
  setClosingModalFlag,
  stopAllVideosInContainer,
  stopVideoPlayback,
  transformToLiteYoutube,
} from '../../utils/control_youtube_video.js'
import { addImageCounter } from '../../utils/e_image_counter.js'
import { loadHlsVideo } from '../../utils/load_hls_video.js'

import { initializeUtagEvents } from './information_modules.analytics.js'

let utagInitialized = false

class InformationModules {
  constructor(blockId) {
    this.blockId = blockId
    this.blocks = this.getBlocks()
    this.relayoutRafByBlock = new WeakMap()
    this.resizeObserverByBlock = new WeakMap()
    this.swiperByBlock = new WeakMap()

    this.bottomSheetInstances = {}

    if (!this.blocks.length) return
    this.init()
  }
  /**
   * We optain the blocks from ID or all
   * @returns {NodeList}Block list
   */

  getBlocks() {
    if (this.blockId) {
      return document.querySelectorAll(`[data-block-id="${this.blockId}"]`)
    }
    return document.querySelectorAll('.js-information-modules')
  }

  lockWrapperHeight(block, isMobile) {
    const wrapper = block.querySelector('.js-information-modules-wrapper')
    if (!wrapper) return

    block.classList.remove('information-modules__structure')
    block.style.height = 'auto'
    block.style.removeProperty('overflow')

    if (block.dataset.shouldLockHeight === '1') {
      wrapper.style.height = 'auto'
      const base = Math.ceil(wrapper.getBoundingClientRect().height)
      const safetyOffset = isMobile ? 8 : 4
      wrapper.style.height = `${base + safetyOffset}px`
    } else {
      wrapper.style.height = ''
    }

    wrapper.classList.remove('visibility-hidden')
  }

  scheduleBlockRelayout(block, swiper, isMobile) {
    const previousRaf = this.relayoutRafByBlock.get(block)
    if (previousRaf) {
      cancelAnimationFrame(previousRaf)
    }

    const rafId = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (swiper && !swiper.destroyed) {
          swiper.update()
        }
        this.lockWrapperHeight(block, isMobile)
      })
    })

    this.relayoutRafByBlock.set(block, rafId)
  }

  bindBlockRelayoutEvents(block, swiper, isMobile) {
    const wrapper = block.querySelector('.js-information-modules-wrapper')
    const imgs = block.querySelectorAll('img')

    if (!imgs.length) {
      this.scheduleBlockRelayout(block, swiper, isMobile)
      return
    }

    imgs.forEach(img => {
      const handleImgReady = () => {
        this.scheduleBlockRelayout(block, swiper, isMobile)
      }

      img.addEventListener('load', handleImgReady, { once: true })
      img.addEventListener('error', handleImgReady, { once: true })

      if (img.complete && (img.currentSrc || img.src)) {
        this.scheduleBlockRelayout(block, swiper, isMobile)
      }
    })

    window.addEventListener(
      'load',
      () => {
        this.scheduleBlockRelayout(block, swiper, isMobile)
      },
      { once: true }
    )

    window.addEventListener('resize', () => {
      this.scheduleBlockRelayout(block, swiper, isMobile)
    })

    if (wrapper && typeof ResizeObserver !== 'undefined' && !this.resizeObserverByBlock.get(block)) {
      const resizeObserver = new ResizeObserver(() => {
        this.scheduleBlockRelayout(block, swiper, isMobile)
      })

      resizeObserver.observe(wrapper)
      this.resizeObserverByBlock.set(block, resizeObserver)
    }
  }
  /**
   * init information modules
   */
  init() {
    loadHlsVideo('.js-information-modules').catch(error => {})
    const isInspirationGuide = document.body.classList.contains('inspiration-guide')
    const isMobile = isInspirationGuide ? window.matchMedia('(max-width: 768px)').matches : currentDevice.isMobile

    Swiper.use([Navigation, Controller, Pagination, Scrollbar])
    this.blocks.forEach(block => {
      this.initBlock(block, isMobile)
    })

    window.addEventListener('pageshow', () => {
      this.blocks.forEach(block => {
        this.scheduleBlockRelayout(block, this.swiperByBlock.get(block), isMobile)
      })
    })

    setTimeout(() => {
      this.blocks.forEach(block => {
        this.scheduleBlockRelayout(block, this.swiperByBlock.get(block), isMobile)
      })
    }, 250)

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        this.blocks.forEach(block => {
          this.scheduleBlockRelayout(block, this.swiperByBlock.get(block), isMobile)
        })
      })
    }

    this.transformExistingYoutubeElements()

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.blocks.forEach(block => this.lockWrapperHeight(block, isMobile))
      })
    })
    if (!utagInitialized) {
      initializeUtagEvents()
      utagInitialized = true
    }
  }

  /**
   *  Init information module items
   * @param {HTMLElement} block
   * @param {boolean} isMobile
   */
  initBlock(block, isMobile) {
    const infoItems = block.querySelectorAll('.js-info-item')
    const mp4Videos = block.querySelectorAll('video.video-content')

    mp4Videos.forEach(video => {
      video.loop = true // Forzar bucle por JS
      video.muted = true // Forzar silencio por JS
      video.setAttribute('playsinline', '') // Forzar reproducción inline

      // Asegurar que si el vídeo se detiene al terminar, vuelva a reproducirse
      video.addEventListener('ended', () => {
        video.currentTime = 0
        video.play()
      })
    })

    infoItems.forEach(infoItem => {
      this.initInfoItem(infoItem)
    })

    const limitOfElements = isMobile ? 1 : 3
    let blockSwiper = null

    block.dataset.shouldLockHeight = infoItems.length > limitOfElements ? '1' : '0'

    if (infoItems.length > limitOfElements) {
      if (isMobile) {
        blockSwiper = this.initSwiper(block, true)
        this.openPanelInformationModule(block)
      } else {
        blockSwiper = this.initSwiper(block, false)
      }

      if (blockSwiper) {
        this.swiperByBlock.set(block, blockSwiper)
        this.scheduleBlockRelayout(block, blockSwiper, isMobile)
        this.bindBlockRelayoutEvents(block, blockSwiper, isMobile)
      }
    }

    const multiModal = block.querySelector('.js-modal-information-module')
    if (multiModal) {
      this.initNfhModal(block, multiModal, isMobile)
    }

    this.initVideoCarousels(block)
  }

  /**
   * Init information module item
   * @param {HTMLElement} infoItem
   */
  initInfoItem(infoItem) {
    const swiperElement = infoItem.querySelector('.swiper.ib-swiper')
    if (!swiperElement) {
      return
    }
    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: false,
      lazyPreloadPrevNext: 1,
      pagination: {
        el: swiperElement.querySelector('.js-swiper-pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: swiperElement.querySelector('.js-swiper-button-prev'),
        nextEl: swiperElement.querySelector('.js-swiper-button-next'),
      },
      on: {
        slideChange() {
          handlerSwiperStatusVideo(this, 'lite-youtube')
        },
      },
    })
  }

  /**
   * Init swiper
   * @param {HTMLElement} block
   * @param {boolean} isMobile
   */
  initSwiper(block, isMobile) {
    const swiperScrollbarN = block.querySelector('.js-swiper-scrollbar-navigation')
    let swiper = null
    if (!swiperScrollbarN) return

    const swiperScrollbarNScroll = swiperScrollbarN.querySelector(
      ':scope > .js-swiper-navigation-wrapper .js-swiper-scrollbar-scroll'
    )

    const swiperConfig = {
      spaceBetween: 12,
      loop: false,
      observer: true,
      observeParents: true,
      scrollbar: {
        el: swiperScrollbarNScroll,
        hide: false,
        draggable: true,
      },
      on: {
        slideChange() {
          handlerSwiperStatusVideo(this, 'lite-youtube')
        },
      },
    }

    if (isMobile) {
      swiperConfig.slidesPerView = 1.2
      swiperConfig.navigation = false
    } else {
      const container = swiperScrollbarN

      const images = container.querySelectorAll('img')
      images.forEach(img => {
        if (img.dataset.mobile) {
          img.src = img.dataset.mobile
        }
      })

      // eslint-disable-next-line no-jquery/no-jquery-constructor
      addImageCounter($(container))

      const swiperScrollbarNScrollPrev = swiperScrollbarN.querySelector(
        ':scope > .js-swiper-navigation-wrapper .js-swiper-button-prev'
      )
      const swiperScrollbarNScrollNext = swiperScrollbarN.querySelector(
        ':scope > .js-swiper-navigation-wrapper .js-swiper-button-next'
      )

      swiperConfig.slidesPerView = 3
      swiperConfig.lazyPreloadPrevNext = 1
      swiperConfig.navigation = {
        prevEl: swiperScrollbarNScrollPrev,
        nextEl: swiperScrollbarNScrollNext,
      }
    }
    swiper = new Swiper(swiperScrollbarN, swiperConfig)
    return swiper
  }
  /**
   * Init modal
   * @param {HTMLElement} block
   * @param {HTMLElement} multiModal
   */
  initNfhModal(block, multiModal, isMobile) {
    this.buildMobileSelector(multiModal)

    const triggerElements = block.querySelectorAll('[data-modal-information]')
    const activeMenuTabButton = multiModal.querySelector('#tab-active-mobile')
    this.initializeTabListeners(multiModal)

    const onMultiModalShow = modal => {
      this.handlerShowFastbooking(modal, '.js-btn-floating-fastbooking')

      const setTexts = modal.querySelectorAll('[data-take-text-from]:not([data-text-filled])')
      setTexts.forEach(textElem => {
        const originId = textElem.dataset.takeTextFrom
        if (!originId) return

        const originElem = document.querySelector(`#${originId}`)
        if (!originElem) return

        const clonedElement = originElem.cloneNode(true)
        textElem.appendChild(clonedElement)
        textElem.dataset.textFilled = ''
      })
      const swiperRender = modal.querySelector('.js-album-container')
      if (swiperRender) {
        const isSwiperInit = modal.querySelector('.swiper-container-initialized')
        if (!isSwiperInit) {
          this.initSwiperModal(modal)
        }
      }
      const youtubeElements = modal.querySelectorAll('div.video-content.js-video-youtube:not(lite-youtube)')
      youtubeElements.forEach(element => {
        const videoId = element.dataset.videoYoutube
        if (videoId) {
          element.dataset.videoId = videoId
          transformToLiteYoutube(element)
        }
      })

      const currentTriggerId = modal.dataset.currentTriggerId
      let targetTabItem = null
      if (currentTriggerId) {
        const targetTabControl = modal.querySelector(`.js-tab-control[aria-controls="panel-${currentTriggerId}"]`)
        if (targetTabControl) {
          targetTabItem = targetTabControl.closest('.js-tab')
        }
      }

      const tabToDisplayItem = targetTabItem || modal.querySelector('.js-tab.active') || modal.querySelector('.js-tab')
      if (tabToDisplayItem) {
        this.updateActiveTabContentAndName(modal, tabToDisplayItem)
        const activeTabControl = tabToDisplayItem.querySelector('.js-tab-control')
        if (activeTabControl) {
          activeTabControl.focus()
        }
      }
    }

    const onMultiModalClose = modal => {
      if (activeMenuTabButton && activeMenuTabButton.classList.contains('s-arrow-up')) {
        activeMenuTabButton.classList.remove('s-arrow-up')
        activeMenuTabButton.classList.add('s-arrow-down')
        activeMenuTabButton.setAttribute('aria-expanded', 'false')
      }

      const tabsListElement = modal.querySelector('.js-tabs-list')
      if (tabsListElement) {
        tabsListElement.classList.remove('visible')
        if (isMobile) {
          tabsListElement.setAttribute('aria-hidden', 'true')
        }
      }

      stopAllVideosInContainer(modal)

      delete modal.dataset.currentTriggerId
    }

    triggerElements.forEach(triggerElement => {
      triggerElement.addEventListener('click', () => {
        const targetTriggerId = triggerElement.dataset.modalInformation

        multiModal.dataset.currentTriggerId = targetTriggerId

        if (currentDevice.isMobile) {
          const sheetId = multiModal.id

          if (!this.bottomSheetInstances[sheetId]) {
            this.bottomSheetInstances[sheetId] = new BottomSheet({
              sheetId: multiModal.id,
              sheetHeight: 100,
              showButton: triggerElement,
            })

            this.bottomSheetInstances[sheetId].addEventListener('show', () => onMultiModalShow(multiModal))
            this.bottomSheetInstances[sheetId].addEventListener('close', onMultiModalClose)
          }
          this.bottomSheetInstances[sheetId].show()
        } else {
          const idModal = multiModal.closest('.js-modal').id
          Modal.show(idModal, {
            onShow: modal => {
              modal.dataset.currentTriggerId = targetTriggerId
              onMultiModalShow(modal)
            },
            onClose: onMultiModalClose,
            awaitCloseAnimation: true,
            awaitOpenAnimation: true,
          })
        }
      })
    })
  }

  initializeTabListeners(el) {
    const tabsListElement = el.querySelector('.js-tabs-list')
    if (!tabsListElement) return

    tabsListElement.addEventListener('click', e => {
      const clickedTabControl = e.target.closest('.js-tab-control')
      if (clickedTabControl) {
        const clickedTabItem = clickedTabControl.closest('.js-tab')
        this.updateActiveTabContentAndName(el, clickedTabItem)
        clickedTabControl.focus()
      }
    })

    tabsListElement.addEventListener('keydown', e => {
      const currentActiveTabControl = el.querySelector('.js-tab-control[aria-selected="true"]')
      if (!currentActiveTabControl) return

      const tabControlElements = Array.from(el.querySelectorAll('.js-tab-control'))
      const currentIndex = tabControlElements.indexOf(currentActiveTabControl)
      let newIndex = -1

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault()
          newIndex = currentIndex - 1
          if (newIndex < 0) newIndex = tabControlElements.length - 1
          break
        case 'ArrowRight':
          e.preventDefault()
          newIndex = currentIndex + 1
          if (newIndex >= tabControlElements.length) newIndex = 0
          break
        case 'Home':
          e.preventDefault()
          newIndex = 0
          break
        case 'End':
          e.preventDefault()
          newIndex = tabControlElements.length - 1
          break
        default:
          return
      }

      if (newIndex !== -1 && tabControlElements[newIndex]) {
        const newTabControl = tabControlElements[newIndex]
        const newTabItem = newTabControl.closest('.js-tab')
        this.updateActiveTabContentAndName(el, newTabItem)
        newTabControl.focus()
      }
    })
  }

  /**
   * Init video carousel
   * @param {HTMLElement} block
   */
  initVideoCarousels(block) {
    const videos = Array.from(block.querySelectorAll('.js-video-youtube')).filter(
      video => !video.closest('.js-sheet-body')
    )

    if (videos.length === 0) return

    const carouselVideos = block.querySelector('.js-swiper-default')
    if (!carouselVideos) return

    const carouselVideosWrapper = carouselVideos.querySelector('.js-swiper-wrapper')
    let modalId

    videos.forEach((video, index) => {
      const swiperSlideDiv = document.createElement('div')
      swiperSlideDiv.classList.add('swiper-slide', 'js-information-module-slide', 'information-modules__modal-slide')

      if (video.tagName.toLowerCase() === 'lite-youtube' || video.classList.contains('js-video-youtube')) {
        const videoId = video.dataset.videoYoutube || video.getAttribute('videoid')

        if (videoId) {
          const liteYoutubeElement = document.createElement('lite-youtube')
          liteYoutubeElement.setAttribute('videoid', videoId)
          liteYoutubeElement.setAttribute('playlabel', 'Reproducir vídeo')
          liteYoutubeElement.setAttribute('posterquality', 'hqdefault')
          liteYoutubeElement.setAttribute('params', 'enablejsapi=1&rel=0')
          liteYoutubeElement.classList.add('video-content', 'js-video-youtube')

          liteYoutubeElement.dataset.videoYoutube = videoId
          liteYoutubeElement.dataset.orderSlide = index

          const cardTitle = video.closest('.utag-information-module')?.dataset.utagBlockTitle || ''
          liteYoutubeElement.setAttribute('data-utag-card-title', cardTitle)

          // Poster Image
          const originalPosterImg = video.querySelector('img[slot="image"]')

          if (originalPosterImg) {
            const imgSlot = document.createElement('img')
            imgSlot.setAttribute('slot', 'image')
            imgSlot.setAttribute('src', originalPosterImg.getAttribute('src'))
            imgSlot.setAttribute('alt', originalPosterImg.getAttribute('alt') || 'Poster')

            imgSlot.style.width = '100%'
            imgSlot.style.height = '100%'
            imgSlot.style.objectFit = 'cover'

            liteYoutubeElement.appendChild(imgSlot)
          }

          swiperSlideDiv.appendChild(liteYoutubeElement)
        }
      } else {
        const videoElement = document.createElement('video')
        videoElement.classList.add('video-content')

        if (video.src) videoElement.src = video.src
        if (video.poster) videoElement.poster = video.poster
        if (video.dataset.src) videoElement.dataset.src = video.dataset.src

        videoElement.controls = true
        videoElement.dataset.orderSlide = index

        swiperSlideDiv.appendChild(videoElement)
      }

      carouselVideosWrapper.appendChild(swiperSlideDiv)

      video.dataset.orderSlide = index

      // Desactivar puntero en la tarjeta de fondo
      video.style.pointerEvents = 'none'

      const contentVideo = video.closest('.image')

      if (contentVideo) {
        modalId = contentVideo.dataset.carouselVideosTrigger

        contentVideo.addEventListener('click', event => {
          event.preventDefault()
          this.openVideoCarouselModal(event, modalId)
        })
      }
    })
  }

  /**
   * Add atribute data-order-slide
   * @param {HTMLElement} element
   * @param {number} position
   */
  addDataOrderSlide(element, position) {
    if (element) {
      element.dataset.orderSlide = position
    }
  }
  /**
   * Transform existing youtube elements to lite-youtube
   */
  transformExistingYoutubeElements() {
    const youtubeElements = document.querySelectorAll('.js-video-youtube:not(lite-youtube)')

    youtubeElements.forEach(element => {
      const videoId = element.dataset.videoYoutube
      if (videoId) {
        element.dataset.videoId = videoId
        transformToLiteYoutube(element)
      }
    })
  }

  /**
   * Open carousel modal
   * @param {Event} event - click event
   * @param {string} modalId
   */
  openVideoCarouselModal(event, modalId) {
    if (!currentDevice.isMobile) {
      Modal.show(modalId, {
        onShow: modal => {
          ScrollLock.on()
          this.initVideoCarouselSwiper(event, modal)
        },
        onClose: modal => {
          ScrollLock.off()
          // 🛑 REFACTOR: Detenemos únicamente los vídeos dentro de la modal al cerrarla
          if (modal) {
            this.stopModalVideos(modal)
          }
        },
        awaitCloseAnimation: true,
        awaitOpenAnimation: true,
      })
    } else {
      const videoBottomSheet = createBottomSheet({
        sheetId: modalId,
        sheetHeight: 100,
        showButton: event?.currentTarget || null,
      })

      videoBottomSheet.show()
      videoBottomSheet.addEventListener('show', bottomSheet => {
        this.initVideoCarouselSwiper(event, bottomSheet)
      })
      videoBottomSheet.addEventListener('close', bottomSheet => {
        this.stopModalVideos(bottomSheet)
      })
    }
  }

  /**
   * Init video carousel swiper
   * @param {Event} event
   * @param {HTMLElement} block
   */
  initVideoCarouselSwiper(event, block) {
    Swiper.use([Pagination, Navigation])

    const swiperDefault = block.querySelector('.js-swiper-default')
    if (!swiperDefault) return
    const swiperDefaultPagination = swiperDefault?.querySelector(':scope > .js-swiper-pagination')
    const swiperDefaultNavigationNext = swiperDefault?.querySelector(':scope > .js-swiper-button-next')

    const spaceBetween = currentDevice.isMobile ? 0 : 20
    const swiperDefaultNavigationPrev = swiperDefault?.querySelector(':scope > .js-swiper-button-prev')
    const orderSlide =
      event.target.dataset.orderSlide || event.target.querySelector('.video-content')?.dataset.orderSlide || 0
    const swiper = new Swiper(swiperDefault, {
      initialSlide: parseInt(orderSlide, 10),
      slidesPerView: 1,
      spaceBetween,
      loop: false,
      pagination: {
        el: swiperDefaultPagination,
        clickable: true,
      },
      navigation: {
        nextEl: swiperDefaultNavigationNext,
        prevEl: swiperDefaultNavigationPrev,
      },
      lazyPreloadPrevNext: 1,
      on: {
        init() {
          handlerSwiperStatusVideo(this, '.js-video-youtube')
        },
        slideChange() {
          handlerSwiperStatusVideo(this, '.js-video-youtube')
        },
      },
    })

    swiper.update()
  }

  /**
   *Stop all modal videos
   * @param {HTMLElement} modal
   */
  stopModalVideos(modal) {
    setClosingModalFlag(true)

    const videos = Array.from(modal.querySelectorAll('.video-content:not(lite-youtube)'))
    const videoLiteYoutube = modal.querySelector('lite-youtube')

    videos.forEach(video => {
      this.stopVideo(video)
    })
    setTimeout(() => {
      stopVideoPlayback(videoLiteYoutube, true)

      setClosingModalFlag(false)
    }, 300)
  }

  /**
   * Stop video HTML5
   * @param {HTMLVideoElement} videoElement - The video element to stop
   */
  stopVideo(videoElement) {
    if (videoElement) {
      videoElement.pause()
      videoElement.currentTime = 0
    }
  }

  /**
   * Set selector for NFH
   * @param {HTMLElement} el
   */
  buildMobileSelector(el) {
    if (currentDevice.isMobile && document.body.classList.contains('hotel-one-landing-page')) {
      const activeMenuTabButton = el.querySelector('#tab-active-mobile')
      const tabsListElement = el.querySelector('.js-tabs-list')

      if (activeMenuTabButton) {
        activeMenuTabButton.addEventListener('click', e => {
          e.preventDefault()
          if (tabsListElement) {
            tabsListElement.classList.toggle('visible')
            const isVisible = tabsListElement.classList.contains('visible')
            tabsListElement.setAttribute('aria-hidden', !isVisible)
            activeMenuTabButton.setAttribute('aria-expanded', isVisible)
          }
          this.toggleArrow(activeMenuTabButton)
        })
      }

      const tabItems = el.querySelectorAll('.js-tab')
      tabItems.forEach(tabItem => {
        tabItem.addEventListener('click', () => {
          if (tabsListElement && tabsListElement.classList.contains('visible')) {
            tabsListElement.classList.remove('visible')
            tabsListElement.setAttribute('aria-hidden', 'true')
          }

          if (activeMenuTabButton && activeMenuTabButton.classList.contains('s-arrow-up')) {
            activeMenuTabButton.classList.remove('s-arrow-up')
            activeMenuTabButton.classList.add('s-arrow-down')
            activeMenuTabButton.setAttribute('aria-expanded', 'false')
          }
        })
      })
    }
  }

  /**
   *
   * @param {HTMLElement} selector
   */
  toggleArrow(selector) {
    if (selector.classList.contains('s-arrow-up')) {
      selector.classList.remove('s-arrow-up')
      selector.classList.add('s-arrow-down')
    } else {
      selector.classList.remove('s-arrow-down')
      selector.classList.add('s-arrow-up')
    }
  }

  /**
   * Update the name of the active tab on mobile devices
   * @param {HTMLElement} el
   */
  updateActiveTabContentAndName(el, clickedTabItem) {
    const activeMenuTabButton = el.querySelector('#tab-active-mobile')

    const currentActiveTabItem = el.querySelector('.js-tab.active')
    if (currentActiveTabItem) {
      const currentActiveTabControl = currentActiveTabItem.querySelector('.js-tab-control')
      currentActiveTabItem.classList.remove('active')
      if (currentActiveTabControl) {
        currentActiveTabControl.setAttribute('aria-selected', 'false')
        currentActiveTabControl.setAttribute('tabindex', '-1')
        const currentPanelId = currentActiveTabControl.getAttribute('aria-controls')
        const currentActivePanel = el.querySelector(`#${currentPanelId}`)
        if (currentActivePanel) {
          currentActivePanel.classList.add('hidden')
          currentActivePanel.setAttribute('aria-hidden', 'true')
        }
      }
    }

    const newActiveTabControl = clickedTabItem.querySelector('.js-tab-control')
    clickedTabItem.classList.add('active')
    if (newActiveTabControl) {
      newActiveTabControl.setAttribute('aria-selected', 'true')
      newActiveTabControl.setAttribute('tabindex', '0')

      const newPanelId = newActiveTabControl.getAttribute('aria-controls')
      const newActivePanel = el.querySelector(`#${newPanelId}`)
      if (newActivePanel) {
        newActivePanel.classList.remove('hidden')
        newActivePanel.setAttribute('aria-hidden', 'false')
      }
    }

    if (activeMenuTabButton) {
      const buttonText = newActiveTabControl
      if (buttonText) {
        activeMenuTabButton.textContent = buttonText.textContent
      }
      const tabsListElement = el.querySelector('.js-tabs-list')
      if (tabsListElement && tabsListElement.classList.contains('visible')) {
        tabsListElement.classList.remove('visible')

        if (activeMenuTabButton.classList.contains('s-arrow-up')) {
          tabsListElement.setAttribute('aria-hidden', 'true')
          activeMenuTabButton.classList.remove('s-arrow-up')
          activeMenuTabButton.classList.add('s-arrow-down')
          activeMenuTabButton.setAttribute('aria-expanded', 'false')
        }
      }
    }
  }

  /**
   * open mobile panel
   * @param {HTMLElement} block
   */
  openPanelInformationModule(block) {
    block.addEventListener('click', e => {
      e.preventDefault()

      const buttonModalTrigger = e.target.closest('.js-show-modal')
      if (!buttonModalTrigger) return

      const modalId = buttonModalTrigger.getAttribute('data-modal')
      if (!modalId) return

      if (currentDevice.isMobile) {
        const sheetId = buttonModalTrigger.dataset.sheetSelector
        if (!this.bottomSheetInstances[sheetId]) {
          this.bottomSheetInstances[sheetId] = createBottomSheet({
            sheetId,
            sheetHeight: 100,
            showButton: buttonModalTrigger,
          })
        }
        this.bottomSheetInstances[sheetId].show()
        this.bottomSheetInstances[sheetId].addEventListener('show', () => {
          stopAllVideosInContainer(document, true)
        })
        this.bottomSheetInstances[sheetId].addEventListener('close', () => {
          stopAllVideosInContainer(document, true)
        })
      } else {
        Modal.show(modalId, {
          triggerElement: buttonModalTrigger,
          onShow: () => {
            ScrollLock.on()

            const modal = document.getElementById(modalId)
            if (modal) {
              const youtubeElements = modal.querySelectorAll('.js-video-youtube:not(lite-youtube)')
              youtubeElements.forEach(element => {
                const videoId = element.dataset.videoYoutube
                if (videoId) {
                  element.dataset.videoId = videoId
                  transformToLiteYoutube(element)
                }
              })
            }
          },
          onClose: () => {
            ScrollLock.off()
            const modal = document.getElementById(modalId)
            if (modal) {
              stopAllVideosInContainer(document, true)
            }
          },
          awaitCloseAnimation: true,
          awaitOpenAnimation: true,
        })
      }
    })
  }

  /**
   *
   * @param {HTMLElement} block
   * @param {string} selector
   **/
  handlerShowFastbooking(modal, selector) {
    const buttons = modal.querySelectorAll(selector)

    buttons.forEach(cta => {
      cta.addEventListener('click', () => {
        Modal.closeAll()

        ScrollLock.off()

        setTimeout(() => {
          fastbooking.openStickyFastbooking()

          if (!currentDevice.isMobile) {
            hideHeaderStickyHotel()
            fastbooking.openDates()
          }
        })
      })
    })
  }

  /**
   * Init module carousel
   * @param {string|HTMLElement} selector
   */
  initSwiperModal(block) {
    const swiperContainer = `.js-swiper-default`
    const container = block.querySelector(swiperContainer)
    const swiperPagination = container.querySelector(':scope > .js-swiper-pagination')
    const swiperNavigationNext = container.querySelector(':scope > .js-swiper-button-next')
    const swiperNavigationPrev = container.querySelector(':scope > .js-swiper-button-prev')

    Swiper.use([Navigation, Pagination])
    new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: swiperPagination,
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },
      navigation: {
        nextEl: swiperNavigationNext,
        prevEl: swiperNavigationPrev,
      },
      lazyPreloadPrevNext: 1,
    })
  }
}

/**
 * Export needed function
 * @param {string|HTMLElement} selector
 */
export function openPanelInformationModule(block) {
  const instance = new InformationModules()
  instance.openPanelInformationModule(block)
}
/**
 * Init information modules
 * @param {string} blockId
 * @returns {InformationModules|boolean}
 */
export function init(blockId) {
  return new InformationModules(blockId)
}
